import styled from 'styled-components';
import type {
  HygienePageRichTextComponent as HygienePageRichTextSchema,
  TextTransform,
} from '@amplience/content-types/typings/c-hygiene-page-rich-text';
import { spacing, useTextTransform } from '@storefront/lib-global';
import { RichTextPartial } from '@storefront/lib-global/partials/richText/RichTextPartial';
import { media } from '@storefront/lib-global/stylings/media';
import { TypographyStyles } from '@storefront/lib-global/stylings/typography';
import { getLocalizedValue } from '@storefront/lib-global/utils/transformers';

export type HygienePageRichTextProps = HygienePageRichTextSchema;

const S = {
  HygienePageRichTextContainer: styled.div`
    @media ${media.greaterThan('lg')} {
      p {
        &:nth-of-type(1) {
          margin-top: 0;
        }

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  `,
  HygienePageRichTextHeading: styled.h1<{ $textTransform: TextTransform }>`
    ${TypographyStyles.Headings.H1}
    margin-bottom: ${spacing.S};
    ${({ $textTransform }) => useTextTransform($textTransform)}

    @media ${media.greaterThan('lg')} {
      margin-bottom: ${spacing.L};
    }
  `,
};

export function HygienePageRichText({
  hygienePageRichText,
  hygienePageRichTextHeading,
  textTransform,
}: HygienePageRichTextProps) {
  return (
    <S.HygienePageRichTextContainer>
      {hygienePageRichTextHeading && (
        <S.HygienePageRichTextHeading $textTransform={textTransform ?? 'UPPERCASE'}>
          {getLocalizedValue(hygienePageRichTextHeading)}
        </S.HygienePageRichTextHeading>
      )}
      <RichTextPartial
        fontSize={TypographyStyles.Body.Small.Regular}
        text={getLocalizedValue(hygienePageRichText?.richText)}
      />
    </S.HygienePageRichTextContainer>
  );
}
